// @ts-check
/** One owner for subscriptions, observers, and other resources. Disposal is idempotent. */
export function createLifetime() {
  /** @type {Array<()=>void>} */
  const cleanups = [];
  let disposed = false;
  return {
    /** @param {()=>void} cleanup */
    add(cleanup) { if (disposed) cleanup(); else cleanups.push(cleanup); return cleanup; },
    /** @param {EventTarget} target @param {string} name @param {EventListener} listener */
    listen(target, name, listener) {
      target.addEventListener(name, listener);
      this.add(() => target.removeEventListener(name, listener));
    },
    dispose() { if (disposed) return; disposed = true; for (const cleanup of cleanups.splice(0).reverse()) cleanup(); },
    get disposed() { return disposed; },
  };
}
